define('glu/grid/filter/multiSelectSearch',['require','exports','module','./fieldSearch','../../date','../../locale','../../util','../../flexDropdown','hbs!./multiSelectSearch.hbs'],function(require, exports, module) {
    'use strict';

    var FieldSearch = require('./fieldSearch'),
        date = require('../../date'),
        locale = require('../../locale'),
        util = require('../../util'),
        FlexDropdown = require('../../flexDropdown');

    //enable configuration at the system level in case certain things need to be different for one application vs another
    var defaultConfig = {
            selectedLabel: locale.get('selected'),
            caseSensitive: true,
            multiSelect: true,
            dropdownFilter: true,
            sort: true
        },
        config = util.extend(defaultConfig, module.config());

    /**
     * Provides a FlexDropdown list of items that can be used to filter a column of the grid.
     *
     *
     * The following options are accepted via a filterOptions hash when the column is defined for the grid:
     * <ul>
     *     <li>valueField - Optional, The field to use to set the value of each entry on the flexdropdown list created, defaults to the current field multiSelect is setup for.</li>
     *     <li>idField - Optional, The field to use to set the id of each entry on the flexdropdown list created, defaults to the current field multiSelect is setup for. Useful if you have a column with an entity and also have an id for that entity as it can make searching huge grids a little faster.</li>
     *     <li>filterOnField - Optional, The field do the actual filtering on where the id or value is compared against this field for each row.</li>
     *     <li>showAllSelected - Optional, If true, all selected options for the filter will display on the filter badge, regardless of the number of items</li>
     * </ul>
     *
     * Supports the following options, all of which can be set at the application level with requireJs configuration or
     * at the individual level via filterOptions for the column when setting up the grid:
     * <ul>
     *     <li>selectedLabel - Optional, set the text to use for the "N Selected" label that shows when you select more items than will fit on the dropdown selected area. Defaults to "Selected"</li>
     *     <li>caseSensitive - Optional, Boolean, whether the match for the item chosen in the dropdown and the column value during filtering is case sensitive.  Defaults to true.</li>
     *     <li>multiSelect - Optional, Boolean, whether the dropdown allows multiple selections or not. Defaults to true.</li>
     *     <li>dropdownFilter - Optional, Boolean, whether the dropdown includes a filter box where you can type and filter the contents of the dropdown. Defaults to true.</li>
     *     <li>sort - Optional, Boolean, whether the data for the dropdown is sorted prior to being used to create the dropdown. The sort is a simple ascending string based sort.  Defaults to true.</li>
     * </ul>
     *
     * Supports the fol
     *
     * @class MultiSelectSearch
     */
    return FieldSearch.extend( /** @lends MultiSelectSearch.prototype */ {
        template: require('hbs!./multiSelectSearch.hbs'),

        regions: {
            select: '.region-multi-select'
        },

        initialize: function() {
            this.filterOptions = this.model.get('filterOptions') || {};
            util.extend(this, config, util.pick(this.filterOptions, util.keys(defaultConfig)));

            this.filterFields = this.configFields();
            this.dropdown = this.createDropdown();

            this.options.grid.masterCollection.on('grid:clear:filter:' + this.filterFields.filterOnField, this.resetFilter);
        },

        onRender: function() {
            this.showDropdown();
        },

        showDropdown: function() {
            this.select.show(this.dropdown);
            this.enableSubmitButton();
        },

        onClose: function() {
            if (this.dropdown) {
                this.dropdown.close();
            }

            this.options.grid.masterCollection.off('grid:clear:filter:' + this.filterFields.filterOnField, this.resetFilter);
        },

        resetFilter: function() {
            this.filterValue = [];
        },

        enableSubmitButton: function() {
            var hasValue = this.filterValue.length;

            this.ui.$submitBtn.prop('disabled', !hasValue);
            this.ui.$clearBtn.toggleClass('hidden', !hasValue);
        },

        /**
         * Determines the fields to use for the values and ids on the dropdown as well as the field to filter on
         * @returns {{valueField: (valueField|*), idField: idField, filterOnField: (filterOnField|idField|valueField|*)}}
         */
        configFields: function() {
            var valueField = this.filterOptions.valueField || this.model.get('field'),
                idField = this.filterOptions.idField,
                filterOnField = this.filterOptions.filterOnField || idField || valueField;

            return {
                valueField: valueField,
                idField: idField,
                filterOnField: filterOnField
            };
        },

        createDropdown: function() {
            var dropdownData = [],
                currentIds = {},
                valueField = this.filterFields.valueField,
                idField = this.filterFields.idField,
                sortData = this.filterOptions.sort !== false,
                dropdown;

            this.options.grid.masterCollection.each(function(item, index) {
                var value = (!util.isNullOrUndefined(valueField) || !util.isNaN(valueField)) ? '' + item.get(valueField) : item.get(valueField),
                    id = idField ? item.get(idField) : value;

                //you cannot filter on nothingness or anything that is "close enough"
                if (!util.isNullOrUndefined(id) && id.length > 0) {
                    if (!currentIds[id]) {
                        currentIds[id] = true;

                        dropdownData.push({
                            id: id,
                            name: value
                        });
                    }
                }
            });

            //sort the data before making the dropdown unless sorting has been explicitly turned off
            if (sortData) {
                this.sortDropdownData(dropdownData);
            }

            dropdown = new FlexDropdown({
                data: dropdownData,
                filter: this.dropdownFilter,
                multiSelect: this.multiSelect,
                preSelectedNames: this.model.get('value'),
                showCancelIcon: true,
                clearBtn: true
            });

            this.filterValue = this.model.get('value') || [];

            this.listenTo(dropdown, 'selectionChanged:id', this.handleDropdownSelection);

            return dropdown;
        },

        sortDropdownData: function(dropdownData) {
            dropdownData.sort(function(a, b) {
                var aName = a.name.toLowerCase(),
                    bName = b.name.toLowerCase();

                if (aName === bName) {
                    return 0;
                } else {
                    return aName > bName ? 1 : -1;
                }
            });
        },

        handleDropdownSelection: function(selectedId) {
            if (this.isClosed) {
                return;
            }
            this.filterValue = selectedId;
            this.enableSubmitButton();
        },

        createFilter: function() {
            var filter = this.buildFilter(this.filterFields.filterOnField, this.filterValue);

            return filter;
        },

        handleSubmit: function(e) {
            var filter;

            e.preventDefault();

            filter = this.buildFilter(this.filterFields.filterOnField, this.filterValue);

            try {
                this.trigger('filter', filter);
            } catch (ex) {
                return false;
            }
            return false;
        },

        buildFilter: function(field, values) {
            var label;

            //if the selected items are showing on the dropdown in the selected area then show them on the filter
            //if "N Selected" is showing because too many are selected then show that on the filter instead
            if (this.filterOptions.showAllSelected || this.dropdown.isSelectedShowing()) {
                label = values.join(', ');
            } else {
                label = values.length + ' ' + this.selectedLabel;
            }

            this.options.grid.masterCollection.trigger('grid:filtered:' + field, values);

            return {
                title: this.model.get('title'),
                value: values,
                label: label,
                type: this.model.get('type') || 'string',
                field: field,
                filter: util.bind(this.filter, this, field, this.buildFilterMatches(values))
            };
        },

        buildFilterMatches: function(values) {
            var caseSensitive = this.filterFields.idField || this.caseSensitive,
                dropdownValue,
                filterValues = {};

            for (var i = 0; i < values.length; i++) {
                dropdownValue = values[i];

                if (!caseSensitive && util.isString(dropdownValue)) {
                    filterValues[dropdownValue.toLowerCase()] = true;
                } else {
                    filterValues[dropdownValue] = true;
                }
            }

            return filterValues;
        },

        filter: function(field, values, model) {
            return !!values[model.get(field)];
        }
    });
});

